import { FCWithChildren } from 'utils/props';

import styles from './library-container.module.css';

export const LibraryContainer: FCWithChildren = ({ children }) => (
  <div className={styles.LibraryContainer}>{children}</div>
);
